const allowedLocales = ['en-au', 'en-ca']

const chatbotHelper = {
  enableChatbot: (locale: string, isFeatureEnabled?: boolean) => allowedLocales.includes(locale) && isFeatureEnabled,
}
export default chatbotHelper
